
import Vue from 'vue';
import {mapState} from 'vuex';
import {GetScopeFromKey, ScopeKey, Scope} from '../store/index';

function scopeKey(scope: string): string {
  const strScope: Scope = GetScopeFromKey(scope as ScopeKey);
  switch (strScope) {
    case 'truck':
      return 'トラック';
    case 'forklift':
      return 'フォークリフト';
    default:
      return 'サポート対象外';
  }
}

type Data = {
  cScope: string | null;
};

type Method = {
  onChange(val: string): void;
};

type Computed = {
  items: {key: string; val: string}[];
  scope: Array<string>;
  currentScope: ScopeKey;
};

export default Vue.extend<Data, Method, Computed>({
  name: 'ScopeSelector',
  data: () => ({
    cScope: '' as string | null,
  }),
  computed: {
    items() {
      return this.scope.map((v: string) => {
        return {
          key: scopeKey(v),
          val: v,
        };
      });
    },
    ...mapState(['scope', 'currentScope']),
  },
  methods: {
    onChange(val: string) {
      this.$store.commit('SET_CURRENTSCOPE', val);
      this.$router.push('/temp');
    },
  },
});
